import { Injectable } from '@angular/core';
import { SimpleConfigBaseFilter } from 'gung-list';
import { Product } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class ProductCapacityFilterService extends SimpleConfigBaseFilter<Product> {
  getName(): string {
    return 'CAPACITY';
  }
  getOptionIds(item: Product): string[] {
    return [item.extra.hlPimItem.ItemSize];
  }
  getOptionName(key: string): string {
    return `${key}`;
  }
}
